export const TYPE = {
    T_UNDEFINED: 0,
    T_NUMBER: 1,
    T_DATE: 2,
    T_BOOLEAN: 3,
    T_TEXT: 4,
    T_ANY: 5,
    T_IDENT: 6,
    T_FUNCTION: 7,
    T_ARRAY: 8,
    T_POPEN: 9,
    T_PCLOSE: 10,
    T_SBOPEN: 11,
    T_SBCLOSE: 12,
    T_COMMA: 13,
    T_NOOP: 14,
    T_PLUS: 15,
    T_MINUS: 16,
    T_TIMES: 17,
    T_DIV: 18,
    T_MOD: 19,
    T_POW: 20,
    T_UNARY_PLUS: 21,
    T_UNARY_MINUS: 22,
    T_NOT: 23,
    T_FIELD: 24,
    T_EQUAL: 25,
    T_NOT_EQUAL: 26,
    T_LESS_THAN: 27,
    T_LESS_OR_EQUAL: 28,
    T_GREATER_THAN: 29,
    T_GREATER_OR_EQUAL: 30,
    T_CONTAINS: 31,
    T_NOT_CONTAINS: 32,
    T_BITWISE_AND: 33,
    T_BITWISE_OR: 34,
    T_BITWISE_XOR: 35,
    T_LOGICAL_AND: 36,
    T_LOGICAL_OR: 37,
    T_TERNARY: 38,
    T_TERNARY_ELSE: 39,
    T_DEGRE: 40,
    A_NONE: 0,
    A_LEFT: 1,
    A_RIGHT: 2
};
